export default __webpack_public_path__ + "static/media/Card.21a58f33.svg";